import Axios from '../context/axios/AxiosControl'

export const getRestaurants = () => async (dispatch) => {
    dispatch({
        type: 'RESTAURANT_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/restaurant/restaurant/getall/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'RESTAURANT_GETALL_SUCCESS',
                payload: data.restaurants
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESTAURANT_NOT_LOADING'
        })
    }
}

export const getRestaurant = (restaurant) => async (dispatch) => {
    dispatch({
        type: 'RESTAURANT_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/restaurant/restaurant/get/'+ restaurant, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'RESTAURANT_GET_SUCCESS',
                payload: data.restaurant
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESTAURANT_NOT_LOADING'
        })
    }
}

export const addRestaurant = (image, restaurantdata) => async (dispatch) => {
    dispatch({
        type: 'RESTAURANT_LOADING'
    })
    try {
        if(image !== null && image !== undefined&& image !== '' && typeof image !== 'string'){
            let formData = new FormData()
            formData.append('image', image)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: localStorage.getItem('jwt')
                }
            })
            restaurantdata.image = data
        }else{
            restaurantdata.image = image
        }

        const { data, status} = await Axios.post('/api/restaurant/restaurant/register', restaurantdata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'RESTAURANT_ADD_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'RESTAURANT_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESTAURANT_NOT_LOADING'
        })
    }
}

export const editRestaurant = (image, restaurantdata, idRestaurant) => async (dispatch) => {
    dispatch({
        type: 'RESTAURANT_LOADING'
    })
    try {
        if(image !== null && image !== undefined&& image !== '' && typeof image !== 'string'){
            let formData = new FormData()
            formData.append('image', image)

            const {data} = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/upload/uploadimage', formData, {
                headers: {
                    'Content-Type': `multipart/form-data`,
                    auth: localStorage.getItem('jwt')
                }
            })
            restaurantdata.image = data
        }else{
            restaurantdata.image = image
        }

        const { data, status} = await Axios.put('/api/restaurant/restaurant/edit/' + idRestaurant, restaurantdata, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'RESTAURANT_EDIT_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'RESTAURANT_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESTAURANT_ERROR'
        })
    }
}

export const enableRestaurant = (idRestaurant) => async (dispatch) => {
    dispatch({
        type: 'RESTAURANT_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/restaurant/restaurant/enable/' + idRestaurant, {}, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'RESTAURANT_ENABLEDISABLE_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'RESTAURANT_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESTAURANT_ERROR'
        })
    }
}

export const disableRestaurant = (idRestaurant) => async (dispatch) => {
    dispatch({
        type: 'RESTAURANT_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/restaurant/restaurant/disable/' + idRestaurant, {}, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 263 || status === 260) {
            dispatch({
                type: 'RESTAURANT_ENABLEDISABLE_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'RESTAURANT_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'RESTAURANT_ERROR'
        })
    }
}